import React from 'react';
import { connect } from 'react-redux';
import './styles.scss';
import HeaderLogo from '../../icons/logo.svg';
import PropTypes from 'prop-types';
import {
    getUser,
    getUserPermissionsKeys,
    getUserRolePermissions,
    getUserRoles,
    getUserPayment,
    getCurrentProfilePicture,
    getCurrentUsername,
    getViewAsPartner,
} from '../../screens/auth/selectors';
import {
    logoutRequested,
    roleSwitchRequested,
} from '../../screens/auth/actions.js';
import Picture from '../../common/Picture';
import { Redirect } from 'react-router-dom';
import {
    ROUTE_PAYMENTS,
    AVAILABLE_PATH,
    ROUTE_404,
    ROUTE_PARTNER_SIGNUP,
} from '../constants';
import { DASHBOARD_VIEW } from '../../screens/auth/constants';
import ViewAsPartner from '../../common/ViewAsPartner';
import { noop } from '../../common/propTypes';

import qs from 'query-string';
import { useLocation } from 'react-router';
import { AVAILABLE_PACKAGES } from '../../screens/auth/constants';
import { INDIVIDUAL_ROLE_ID } from '../constants';

function Header({
    onLogout,
    permissions,
    roles,
    onRoleSwitch,
    payment,
    name,
    profilePicture,
    viewAsPartner,
    rolePermissions,
}) {
    const location = useLocation();
    const queryParams = qs.parse(location.search);

    // if user does not have `DASHBOARD_VIEW` permission, OR package is mentioned in the URL then he is not a paid user
    if (payment) {
        return (
            <Redirect
                to={{
                    ...location,
                    pathname: ROUTE_PARTNER_SIGNUP,
                }}
            />
        );
    }
    if (
        (permissions.length && !permissions.includes(DASHBOARD_VIEW)) ||
        (queryParams.package &&
            AVAILABLE_PACKAGES[queryParams.package.toUpperCase()] &&
            INDIVIDUAL_ROLE_ID.includes(rolePermissions.roleId))
    ) {
        return (
            <Redirect
                to={{
                    ...location,
                    pathname: ROUTE_PAYMENTS,
                }}
            />
        );
    }
    let redirect404 = true;

    AVAILABLE_PATH.forEach((path) => {
        if (location.pathname.includes(path)) {
            redirect404 = false;
        }
    });

    if (redirect404) {
        return (
            <Redirect
                to={{
                    pathname: ROUTE_404,
                }}
            />
        );
    }

    return (
        <div id="header">
            <nav className="navbar navbar-expand-lg bg-white fixed-top">
                <div className="col">
                    <a className="navbar-brand">
                        <img
                            src={HeaderLogo}
                            className="Header-branding-logo"
                            alt="litterati"
                        />
                    </a>
                </div>
                <div className="col">
                    <ViewAsPartner />
                </div>
                <div className="col dropdown-wrapper">
                    <ul className="navbar-nav">
                        <li className="nav-item dropdown form-inline">
                            <Picture source={profilePicture} variant={'XS'} />
                            <a
                                className={`nav-link dropdown-toggle ${
                                    viewAsPartner ? 'disable-anchor' : ''
                                }`}
                                href="#"
                                id="navbarDropdownMenuLink"
                                role="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                {name}
                            </a>
                            <div
                                className="dropdown-menu"
                                aria-labelledby="navbarDropdownMenuLink"
                            >
                                {roles.length
                                    ? roles.map((single) => {
                                          return rolePermissions.roleId !=
                                              single.roleId ? (
                                              <a
                                                  key={single.key}
                                                  className="dropdown-item"
                                                  onClick={(e) => {
                                                      e.preventDefault();
                                                      onRoleSwitch(
                                                          single.roleId,
                                                      );
                                                  }}
                                              >
                                                  <i className="icon-profile-icon"></i>
                                                  Switch To {single.name}
                                              </a>
                                          ) : null;
                                      })
                                    : null}

                                <a
                                    className="dropdown-item"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onLogout();
                                    }}
                                >
                                    <i className="icon-power-icon"></i>
                                    Logout
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
}

Header.propTypes = {
    user: PropTypes.object.isRequired,

    // function to be triggered when user clicks on logout
    onLogout: PropTypes.func.isRequired,

    /**
     * @property {array[string]} permissions - array containing all the permission keys of the current user
     */
    permissions: PropTypes.array.isRequired,

    /**
     * @property {array} roles - roles of the currently logged in user
     */
    roles: PropTypes.array,

    /**
     * @property {int} role - current active role of the user
     */
    rolePermissions: PropTypes.object,

    /**
     * @property {function} onRoleSwitch - function to be invoked when user request role switch
     */
    onRoleSwitch: PropTypes.func,

    payment: PropTypes.object,
    name: PropTypes.string,
    profilePicture: PropTypes.string,
    viewAsPartner: PropTypes.bool,
};

Header.defaultProps = {
    roles: [],
    onRoleSwitch: noop,
};

const mapStateToProps = (state) => {
    return {
        user: getUser(state),
        permissions: getUserPermissionsKeys(state),
        roles: getUserRoles(state),
        rolePermissions: getUserRolePermissions(state),
        payment: getUserPayment(state),
        name: getCurrentUsername(state),
        profilePicture: getCurrentProfilePicture(state),
        viewAsPartner: getViewAsPartner(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogout: () => dispatch(logoutRequested()),
        onRoleSwitch: (role) => dispatch(roleSwitchRequested(role)),
    };
};

const ConnectedHeader = connect(mapStateToProps, mapDispatchToProps)(Header);
export default ConnectedHeader;
